module.exports = __webpack_public_path__ + "img/logo_coreevent.3f20202d.svg";